var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import useDropdownContext from '../dropdown-context';
import { useLocation } from 'react-router-dom';
import { treatSpaceOrEnterAsClick } from '~/helpers/events';
import './menu-expander.scss';
function useCloseOnLocationChange(toggleActive, active) {
    const location = useLocation();
    const { setActiveDropdown } = useDropdownContext();
    const activeRef = React.useRef();
    activeRef.current = active;
    React.useEffect(() => {
        if (activeRef.current) {
            toggleActive(false);
            setActiveDropdown({});
        }
    }, [location, toggleActive, setActiveDropdown]);
}
export default function MenuExpander(_a) {
    var { active, toggleActive } = _a, props = __rest(_a, ["active", "toggleActive"]);
    const onClickAndBlur = React.useCallback((event) => {
        toggleActive();
        event.currentTarget.blur();
    }, [toggleActive]);
    useCloseOnLocationChange(toggleActive, active);
    return (React.createElement("button", Object.assign({ type: "button", className: "expand", "aria-haspopup": "true", "aria-label": "Toggle Meta Navigation Menu", tabIndex: 0, onClick: onClickAndBlur, onKeyDown: treatSpaceOrEnterAsClick }, props),
        React.createElement("span", null)));
}
